/** Tokens formulaire — Figma flux déchets (2482-24965, 2482-24561) */

export { SETTINGS_WIZARD_OUTER_MAX_WIDTH_PX as WASTE_WIZARD_CONTENT_WIDTH_PX } from "../settingsWizardConstants";

/** Largeur panneau formulaire / cartes matières (px) */
export const WASTE_FORM_PANEL_WIDTH_PX = 640;

export const WASTE_FORM_LABEL_CLASS =
  "inline-flex items-center gap-[2px] text-[14px] leading-[22px] font-semibold text-[#222222]";

export const WASTE_FORM_REQUIRED = (
  <span className="text-[#AF2F3C]" aria-hidden>
    *
  </span>
);

/** Champs texte / select — hauteur 40px (aligné parcours « Nouveau Site » / Paramètres) */
export const WASTE_FORM_INPUT_CLASS =
  "w-full box-border h-10 min-h-10 border border-[#d3d3d3] rounded px-3 text-[14px] leading-[22px] text-[#222222] bg-white outline-none focus:border-[#00A7A6]";
